export default __webpack_public_path__ + "static/media/PinPinMap.871168bc.jpg";